import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailTemp } from '../../model/chat.model'; // Define this interface in a separate file or within the component
import { EmailService } from '../../service/email.service';
import { ToastrService } from 'ngx-toastr'
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-create-template',
    templateUrl: './create-template.component.html',
    styleUrl: './create-template.component.scss',
    standalone: false
})
export class CreateTemplateComponent implements OnInit {
  profileForm: FormGroup;
  isEditMode: boolean = false;
  isSubmitted: boolean = false;
  templateId: number;
  initialFormState: any;
  isButtonDisabled = true;
  userId: number = 0;
  constructor(
    private fb: FormBuilder,
    private emailService: EmailService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute, private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.profileForm = this.fb.group({
      template_name: ['', Validators.required],
      subject: ['', Validators.required],
      body: ['', Validators.required]
    });

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.templateId = +id;
        this.isEditMode = true;
        this.initializeForm();
        this.loadTemplateData(this.templateId);
      }
    });
  }
  initializeForm(): void {
    this.profileForm = this.fb.group({
      template_name: ['', Validators.required],
      subject: ['', Validators.required],
      body: ['', Validators.required]
    });
    if (!this.isEditMode) {
      this.isButtonDisabled = false;
    }
      this.initialFormState = this.profileForm.value;
  }
  

  loadTemplateData(id: number): void {
    this.emailService.getTemplateById(id).subscribe(data => {
      if (data && data.email_notification) { // Check for existence of templateInfo
        this.profileForm.patchValue({
          template_name: data.email_notification.template_name || '',
          subject: data.email_notification.subject || '',
          body: data.email_notification.body || ''
        });
      } else {
        this.toastr.error('Template not found.');
        this.router.navigate(['/app-email-template']);
      }
    }, error => {
      this.toastr.error('Failed to load template data.');
    });
  }
  
  
  cancel() {
    this.profileForm.reset(this.initialFormState);
    // this.clearFormArrays(); 
  }
  

  onSubmit(): void {
    this.isSubmitted = true;
    if (this.profileForm.valid) {
      const formData = {
        template_name: this.profileForm.value.template_name,
        subject: this.profileForm.value.subject,
        body: this.profileForm.value.body,
        created_by:this.userId
      };

     
        this.emailService.createTemplate(formData).subscribe(
          response => {
            this.toastr.success('Template created Successfully!');
            this.router.navigate(['/app-email-template']);
          },
          error => {
            this.toastr.error('Failed to create template.');
          }
        );
      }
    
  }
  onEditEnable() {
    this.enableForm();
    this.isButtonDisabled = false;
  }
  enableForm(): void {
    this.profileForm.enable();
  }
  getFormData(): { [key: string]: any } {
    return {
        template_name: this.profileForm.get('template_name').value,
        subject: this.profileForm.get('subject').value,
        body: this.profileForm.get('body').value,
        // Include any other required fields here
    };
}

  onEdit () {
    this.isSubmitted = true;
    if (this.profileForm.valid) {
      const formData = this.getFormData();
      this.emailService.updateEmailTemplate( formData,this.templateId).subscribe({
        next: response => {
          if (response) {
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              width: '350px',
              data: { message: `You have successfully updated the Email Template!`, okOnly: true }
            });
        
            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/app-email-template'], { skipLocationChange: true});
            });
          }
        },
        error: error => {
          console.error('Error updating item:', error);
        }
      });
    } else {
      // Form is invalid, log errors to console
      this.toastr.error('Please correct the errors in the form before submitting.', 'Form Invalid');
      //this.logFormErrors();
    }
  }

  backbutton() {
    this.router.navigate(['/app-email-template']);
  }}
